import { API } from '@/utils/request'
import { SYSTEM } from './apiMap'

export default {
  /** =================================================  公共 =========================================================*/
  /**
   * @method: getPublicConfig
   * @description: 获取公众号配置
   * @author: BrandBin
   * @update: 2020-09-27
   * @param {Object} params
   * @return{Object} 成功与否
   */
  getPublicConfig(params, callback) {
    return API.get(SYSTEM.PUBLIC.CONFIG, params, callback)
  },
  /**
   * @method: reportPublicBuryingPoint
   * @description: 埋点统计
   * @author: BrandBin
   * @update: 2020-09-30
   * @param {Object} params
   * @return{Object} 成功与否
   */
  reportPublicBuryingPoint(params, callback) {
    return API.post(SYSTEM.PUBLIC.REPORT, params, callback)
  },
  /**
   * @method: login
   * @description: 登录接口
   * @author: ProudBin
   * @update: 2019-06-04
   * @param {Object} params {agentAccount:'账号',pwd:'加密密码'}
   * @return{Object} 成功与否
   */
  login(params, callback) {
    return API.post(SYSTEM.USER.LOGIN, params, callback)
  },
  /** =================================================  活动 =========================================================*/
  /**
   * @method: getActivityPayDetail
   * @description: 获取付费活动详情
   * @author: BrandBin
   * @update: 2020-09-27
   * @param {Object} params
   * @return{Object} 成功与否
   */
  getActivityPayDetail(params, callback) {
    return API.get(SYSTEM.ACTIVITY.PAY, params, callback)
  },
  /** =================================================  课件相关 =====================================================*/
  /**
   * @method: getUserLoginTicket
   * @description: 获取用户登录凭证
   * @author: BrandBin
   * @update: 2021-01-05
   * @param {Object} params
   * @return{Object} 成功与否
   */
  getUserLoginTicket(params, callback) {
    return API.get(SYSTEM.COURSE.TICKET, params, callback)
  },
  /**
   * @method: pollingUserLogin
   * @description: 轮询查询并登录
   * @author: BrandBin
   * @update: 2021-01-05
   * @param {Object} params
   * @return{Object} 成功与否
   */
  pollingUserLogin(params, callback) {
    return API.get(SYSTEM.COURSE.LOGIN, params, callback)
  },
  /**
   * @method: getAllClassList
   * @description: 获取老师任教班级
   * @author: BrandBin
   * @update: 2021-01-05
   * @param {Object} params
   * @return{Object} 成功与否
   */
  getAllClassList(params, callback) {
    return API.get(SYSTEM.COURSE.CLASS_LIST, params, callback)
  },
  /**
   * @method: getCourseList
   * @description: 获取课件列表
   * @author: BrandBin
   * @update: 2021-01-05
   * @param {Object} params
   * @return{Object} 成功与否
   */
  getCourseList(params, callback) {
    return API.get(SYSTEM.COURSE.COURSE_LIST, params, callback)
  },
  /**
   * @method: getCourseIntroduce
   * @description: 获取课件介绍
   * @author: BrandBin
   * @update: 2021-01-05
   * @param {Object} params
   * @return{Object} 成功与否
   */
  getCourseIntroduce(params, callback) {
    return API.get(SYSTEM.COURSE.INTRODUCE, params, callback)
  },
  /** =================================================  借阅记录 =====================================================*/
  /**
   * @method: getBorrowedRecordList
   * @description: 获取借阅记录
   * @author: BrandBin
   * @update: 2021-04-26
   */
  getBorrowedRecordList(params, callback) {
    return API.get(SYSTEM.BORROWED_RECORD.LIST, params, callback)
  },
  /** =================================================  网络电话 =====================================================*/
  /**
   * @method: getCloudCallSDKURL
   * @description: 获取网络电话SDK
   * @author: BrandBin
   * @update: 2023-02-28
   */
  getCloudCallSDKURL(params, callback) {
    return API.get(SYSTEM.CLOUD_CALL_SDK_URL, params, callback)
  }
}
